import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Company } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query searchStorages($where: StoragesWhereInput, $limit: Int, $offset: Int) {
    storages(
      where: $where
      orderBy: name_asc
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-storages-input',
  templateUrl: './fc-storages-input.component.html',
  styleUrls: ['./fc-storages-input.component.scss']
})
export class FcStoragesInputComponent {

  @Input()
  public control: FormControl;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string, limit: number, offset: number): Promise<Company[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            nameContains: searchTerm,
            archived: false
          },
          limit: limit,
          offset: offset
        },
      })
      .toPromise()
      .then((result) => {
        return result.data['storages']['items'];
      })
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  displayWith(value: Company): string {
    return value && value.name;
  }

}
